import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Avatar, DatePicker, Form, Input, Spin, Select, Image, Upload, Switch } from "antd";
import { useDispatch, useSelector } from "react-redux";
import Lock from "../../../assets/auth/Lock";
import { ChangePasswordApi, LogoutApi, GetUserApi, UpdateUserApi, UpdateParentVisibilityApi } from "../../../api/request/users.js";
import { GetAllCountryApi } from "../../../api/request/common.js";
import LoadableButton from "../../../components/buttons/LoadableButton.jsx";
import { setloggedIn, setUserDetails } from "../../../store/Slices/userSlice.js";
import { removeCookies } from "../../../services/Cookies.jsx";
import { useNavigate } from "react-router-dom";
import Edit from "../../../assets/Edit.jsx";
import Copy from "../../../components/copy/Copy.jsx";
import moment from "moment";
import ModalComponent from "../../../components/modals/ModalComponent.jsx";
import dayjs from 'dayjs';
import { ForgetOtp2FAApi, Request2faChangeApi } from "../../../api/request/users";

const { Dragger } = Upload;

export default function Profile({ isDrawer }) {
  const [form] = Form.useForm();
  const [updateForm] = Form.useForm();
  const [formotp] = Form.useForm()
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userDetails } = useSelector((state) => state.user);
  const [user, setUser] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingProfile, setIsLoadingProfile] = useState(false);
  const [updateInitialValues, setUpdateInitialValues] = useState({ FirstName: '', LastName: '', PhoneNo: '', ProfileImage: '', DOB: '', Skype: '', Telegram: '', Facebook: '', LinkedIn: '', ExpAsIb: '', NumberofClients: '', WorkingExp: '', Fax: '', Telephone: '', CountryOfBirth: null, CountryOfCitizenship: null, City: '', RecoveryContact: '', FamilyName: '' });
  const [isLoadingProfileUpdate, setIsLoadingProfileUpdate] = useState(false);
  const [isOpenProfileUpdateModal, setIsOpenProfileUpdateModal] = useState(false);
  const [isOpen2FAModal, setIsOpen2FAModal] = useState(false);
  const [countries, setCountries] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [fileList, setFileList] = useState([]);
  const [parentChecked, setParentChecked] = useState(false);
  const [FormData, setFormData] = useState({ email: "" });
  const [verifyWithOpt, setVerifyWithOpt] = useState(() => {
    const stored = localStorage.getItem("verifyWithOpt");
    return stored ? JSON.parse(stored) : false;
  });
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(0);
  const [intervalId, setIntervalId] = useState(null);

  const formatTime = (timer) => {
    const minutes = Math.floor(timer / 60);
    const remainingSeconds = timer % 60;
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(remainingSeconds).padStart(2, '0');

    return `${formattedMinutes}:${formattedSeconds}`;
  };
  const getBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("verifyWithOpt"));

    if (stored !== null) {
      setVerifyWithOpt(JSON.parse(stored)); // convert "true"/"false" to boolean
    }
  }, []);


  const handleChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
    updateForm.setFieldsValue({ ProfileImage: newFileList });
    if (newFileList?.length == 0) {
      updateForm.setFieldsValue({ ProfileImage: null });
    }
  }

  const UploadButton = (
    <button type="button">
      <div className="flex justify-center"><img src="/assets/icons/Upload_Document_icon.svg" alt="icon" /></div>
      Upload
    </button>
  );

  const filterOption = (input, option) => {
    return (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
  };

  const getContriens = async () => {
    try {
      const { data } = await GetAllCountryApi();
      if (data?.success) {
        setCountries(
          data?.data?.map((item) => ({
            ...item,
            value: item?.id,
            label: item?.countryName,
          }))
        );
      }
    } catch (error) { }
  };

  const handleSubmit = async (values) => {
    const { oldPassword, newPassword, confirmPassword } = values;

    if (newPassword !== confirmPassword) {
      toast.error("New password and confirm password do not match.");
      return;
    }

    const params = {
      id: userDetails?._id,
      oldPassword,
      password: newPassword,
      confirmPassword,
    };
    try {
      setIsLoading(true);
      const { data } = await ChangePasswordApi(params);
      if (data?.success) {
        toast.success(data?.message);
        form.resetFields();
        logoutHandler();
        
      }
      setIsLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.error?.message);
      setIsLoading(false);
    }
  };

  const logoutHandler = async () => {
    try {
      setIsLoading(true);
      const { data } = await LogoutApi(userDetails?._id);
      if (data?.success) {
      }
      localStorage.clear();
      dispatch(setloggedIn(false));
      removeCookies("token");
      navigate("/");
      setIsLoading(false);
    } catch (err) {
      dispatch(setloggedIn(false));
      removeCookies("token");
      navigate("/");
    }
  };

  useEffect(() => {
    if (!isDrawer) {
      form.resetFields();
    }
  }, [isDrawer]);

  const getUser = async () => {
    try {
      setIsLoadingProfile(true);
      const { data } = await GetUserApi(userDetails?._id);
      setUser(data?.data);
      if (data?.data?.profileImage) {
        setPreviewImage(data?.data?.profileImage);
      }
      updateForm.setFieldsValue({
        FirstName: data?.data?.firstName,
        LastName: data?.data?.lastName,
        PhoneNo: data?.data?.phoneNo,
        ProfileImage: data?.data?.profileImage,
        DOB: data?.data?.dob && moment(moment(data?.data?.dob).format('MM/DD/YYYY'), 'MM/DD/YYYY'),
        ExpAsIb: data?.data?.expAsIb,
        City: data?.data?.city,
      });
      dispatch(setUserDetails({ ...userDetails, profileImage: data?.data?.profileImage }));
      setIsLoadingProfile(false);
    } catch (error) {
      setIsLoadingProfile(false);
    }
  }

  useEffect(() => {
    getUser();
  }, [isOpenProfileUpdateModal]);

  const updateUserProfile = async (values) => {
    const extractOriginFileObjs = (fileArray) => {
      return fileArray[0]?.originFileObj;
    };
    try {
      setIsLoadingProfileUpdate(true);
      let apiHeader = { headers: { Accept: "application/json", "Content-Type": "multipart/form-data" } };
      let params = {
        UserId: userDetails?._id,
        DOB: updateForm.getFieldValue('DOB') ? moment(updateForm.getFieldValue('DOB')).format('MM/DD/YYYY') : '',
        ...values,
        ...(values?.ProfileImage?.length && { ProfileImage: extractOriginFileObjs(values?.ProfileImage) })
      }
  
      const { data } = await UpdateUserApi({ ...params }, apiHeader);
      if (data?.success) {
        setIsOpenProfileUpdateModal(false);
        updateForm.resetFields();
        setFileList([]);
        setPreviewImage('');
        setPreviewOpen(false);
        toast.success(data?.message);
        getUser();
      }
      setIsLoadingProfileUpdate(false);
    } catch (error) {
      
      if (error?.response?.data?.error?.message) {
        toast.error(error?.response?.data?.error?.message);
      }
      setIsLoadingProfileUpdate(false);
    }
  }

  const openUpdateHandle = () => {
    getContriens();
    setIsOpenProfileUpdateModal(true);
  }



  const resendOTPHandler = async (values) => {
    try {
      const { data } = await Request2faChangeApi(values);
      if (data?.success) {
        toast.success(data?.message);
        return true;
      }
    } catch (err) {
      console.error(err);
    }
    return false;
  };

  useEffect(() => {
    try {
      const stored = localStorage.getItem("verifyWithOpt");
      if (stored !== null) {
        setVerifyWithOpt(JSON.parse(stored));
      }
    } catch (err) {
      
    }
  }, []);

  useEffect(() => {
    if (isOpen2FAModal) {
      setTimer(120);
      if (intervalId) {
        clearInterval(intervalId);
      }

      const id = setInterval(() => {
        setTimer(current => {
          if (current <= 1) {
            clearInterval(id);
            return 0;
          }
          return current - 1;
        });
      }, 1000);

      setIntervalId(id);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
        setIntervalId(null);
      }
    };
  }, [isOpen2FAModal]);

  useEffect(() => {
    if (timer <= 0) return;

    const id = setInterval(() => {
      setTimer(prev => {
        if (prev <= 1) {
          clearInterval(id);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    setIntervalId(id);
    return () => clearInterval(id);
  }, [timer]);


  const open2FAHandle = async () => {
    setLoading(true);
    const success = await resendOTPHandler(!verifyWithOpt);
    setLoading(false);
    if (success) {
      setFormData({ otp: "" });
      setTimer(120);
      setIsOpen2FAModal(true);
    }
  };

  const handleSubmit2FA = async (values) => {
    const { otp } = values;

    if (!otp) {
      toast.error("OTP can not be empty.");
      return;
    }

    try {
      setIsLoading(true);
      let params = {
        userId: userDetails?._id,
        Otp: otp,
        isActiveFlag: !verifyWithOpt,
      };
      const { data } = await ForgetOtp2FAApi(params);

      if (data?.success) {
        toast.success(data?.message);
        const newValue = !verifyWithOpt;
        setVerifyWithOpt(newValue);
        localStorage.setItem("verifyWithOpt", JSON.stringify(newValue));
        formotp.resetFields();
        setIsOpen2FAModal(false);
      }

      setIsLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.error?.message || "Something went wrong");
      setIsLoading(false);
    }
  };


  const handleDateChange = (date) => {
    if (date) {
      const formattedDate = dayjs(date).format('MM/DD/YYYY');
      updateForm.setFieldsValue({
        DOB: moment(formattedDate, 'MM/DD/YYYY'),
      });
    } else {
      updateForm.setFieldsValue({
        DOB: '',
      });
    }
  };

  const handleParentChange = async (checked) => {
    try {
      const { data } = await UpdateParentVisibilityApi(userDetails?._id, new URLSearchParams({ status: checked }).toString());
      if (data?.success) {
        setParentChecked(checked);
        toast.success(data?.message);
      }
    } catch (error) {
      if (error?.response?.data?.error?.messag) {
        toast.error(error?.response?.data?.error?.message);
      }
    }
  }

  const openInNewTab = (url) => {
    window.open(url, "_blank");
  };
  const onChange = (e) => {
    const newValue = e.target ? e.target.value : e;
    setFormData({ ...FormData, otp: newValue });
  };
  const sharedProps = {
    onChange,
  };

  return (
    <div>
      <div className="border rounded-lg flex justify-between items-start p-5">
        <div className="flex items-center">
          <Avatar size={60} className="uppercase bg-primary" src={user?.profileImage}>{user?.firstName?.charAt(0)}{user?.lastName?.charAt(0)}</Avatar>
          <div className="ml-4">
            <p className="font-medium text-lg">{user?.firstName} {user?.lastName}</p>
            <p className="text-[#848484] text-lg mt-1">
              {userDetails?.address}
            </p>
          </div>
        </div>
      </div>

      <div className="border rounded-lg p-4 mt-4">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <p className="font-medium text-xl">Personal Information</p>
          <div className="cursor-pointer" onClick={openUpdateHandle}>
            <Edit />
          </div>
        </div>
        {
          isLoadingProfile ? (
            <div className="flex justify-center flex-col my-[40%]">
              <Spin size="large" />
              <p className="primary text-center mt-2">Loading...</p>
            </div>
          ) : (
            <div className="grid sm:grid-cols-2 grid-cols-1 mt-5 items-center gap-5">
              <div>
                <p className="text-[#848484] font-normal text-base">First Name</p>
                <p className="primary font-semibold text-base mt-1">{user?.firstName || '--'}</p>
              </div>
              <div>
                <p className="text-[#848484] font-normal text-base">Last Name</p>
                <p className="primary font-semibold text-base mt-1">{user?.lastName || '--'}</p>
              </div>
              <div>
                <p className="text-[#848484] font-normal text-base">Email Address</p>
                <p className="primary font-semibold text-base mt-1">{user?.email || '--'}</p>
              </div>
              <div>
                <p className="text-[#848484] font-normal text-base">City</p>
                <p className="primary font-semibold text-base mt-1">{user?.city || '--'}</p>
              </div>
              {user?.skype &&
                <div>
                  <p className="text-[#848484] font-normal text-base">Skype</p>
                  <div className="flex items-center gap-3">
                    <p className="primary font-semibold text-base mt-1 cursor-pointer hover:underline" onClick={() => openInNewTab(user?.skype)}>Open Profile</p>
                    <Copy text={user?.skype} />
                  </div>
                </div>
              }
              {user?.telegram &&
                <div>
                  <p className="text-[#848484] font-normal text-base">Telegram</p>
                  <div className="flex items-center gap-3">
                    <p className="primary font-semibold text-base mt-1 cursor-pointer hover:underline" onClick={() => openInNewTab(user?.telegram)}>Open Profile</p>
                    <Copy text={user?.telegram} />
                  </div>
                </div>
              }
              {user?.facebook &&
                <div>
                  <p className="text-[#848484] font-normal text-base">Facebook</p>
                  <div className="flex items-center gap-3">
                    <p className="primary font-semibold text-base mt-1 cursor-pointer hover:underline" onClick={() => openInNewTab(user?.facebook)}>Open Profile</p>
                    <Copy text={user?.facebook} />
                  </div>
                </div>
              }
              {user?.linkedIn &&
                <div>
                  <p className="text-[#848484] font-normal text-base">LinkedIn</p>
                  <div className="flex items-center gap-3">
                    <p className="primary font-semibold text-base mt-1 cursor-pointer hover:underline" onClick={() => openInNewTab(user?.linkedIn)}>Open Profile</p>
                    <Copy text={user?.linkedIn} />
                  </div>
                </div>
              }
              <div>
                <p className="text-[#848484] font-normal text-base">Experience As IB</p>
                <p className="primary font-semibold text-base mt-1">{user?.expAsIb || '--'}</p>
              </div>
              <div>
                <p className="text-[#848484] font-normal text-base">Number Of Clients</p>
                <p className="primary font-semibold text-base mt-1">{user?.numberofClients || '--'}</p>
              </div>
              <div>
                <p className="text-[#848484] font-normal text-base">Working Experience</p>
                <p className="primary font-semibold text-base mt-1">{user?.workingExp || '--'}</p>
              </div>
              <div>
                <p className="text-[#848484] font-normal text-base">Fax</p>
                <p className="primary font-semibold text-base mt-1">{user?.fax || '--'}</p>
              </div>
              <div>
                <p className="text-[#848484] font-normal text-base">Telephone</p>
                <p className="primary font-semibold text-base mt-1">{user?.telephone || '--'}</p>
              </div>
              <div>
                <p className="text-[#848484] font-normal text-base">Date Of Birth</p>
                <p className="primary font-semibold text-base mt-1">{user?.dob ? moment(user?.dob).format('DD/MM/YYYY') : '--'}</p>
              </div>
              <div>
                <p className="text-[#848484] font-normal text-base">Country Of Birth</p>
                <p className="primary font-semibold text-base mt-1">{user?.countryOfBirth || '--'}</p>
              </div>
              <div>
                <p className="text-[#848484] font-normal text-base">Country Of Citizenship</p>
                <p className="primary font-semibold text-base mt-1">{user?.countryOfCitizenship || '--'}</p>
              </div>
              <div>
                <p className="text-[#848484] font-normal text-base">Recovery Contact</p>
                <p className="primary font-semibold text-base mt-1">{user?.recoveryContact || '--'}</p>
              </div>
              <div>
                <p className="text-[#848484] font-normal text-base">Family Name</p>
                <p className="primary font-semibold text-base mt-1">{user?.familyName || '--'}</p>
              </div>
            </div>
          )
        }
      </div>

      {
        (user?.isIBUser === 'Yes') &&
        (
          <div className='flex items-center border rounded-lg p-4 mt-4'>
            <Switch checkedChildren="ON" unCheckedChildren="OFF" checked={parentChecked} onChange={handleParentChange} />
            <p className='text-[#848484] font-semibold text-base ms-2'>Visible as Parent</p>
          </div>
        )
      }

      <div className='flex items-center border rounded-lg p-4 mt-4'>
        <Switch
          checkedChildren="ON"
          unCheckedChildren="OFF"
          checked={verifyWithOpt}
          loading={loading}
          onClick={open2FAHandle}
        />
        <p className='text-[#848484] font-semibold text-base ms-2'>Two Factor Authentication (2FA)</p>
      </div>

      <Form autoComplete="off" onFinish={handleSubmit} form={form}>
        <div className="p-5 grid grid-cols-1 gap-6">
          <div>
            <p className="text-xl font-medium">Change Password</p>
            <p className="mt-1 text-sm">
              To change your password, please fill in the below fields.
            </p>
          </div>
          <div className="sm:w-[65%] w-full">
            <p className="mb-1">Current Password</p>
            <Form.Item
              name="oldPassword"
              rules={[
                {
                  required: true,
                  message: "Please input your current password!",
                },
              ]}
            >
              <Input.Password
                size="large"
                placeholder="Current Password"
                prefix={<Lock />}
              />
            </Form.Item>
          </div>
          <div className="sm:w-[65%] w-full">
            <p className="mb-1">New Password</p>
            <Form.Item
              name="newPassword"
              hasFeedback
              rules={[
                { required: true, message: "Please input your new password!" },
              ]}
            >
              <Input.Password
                size="large"
                placeholder="New Password"
                prefix={<Lock />}
              />
            </Form.Item>
          </div>
          <div className="sm:w-[65%] w-full">
            <p className="mb-1">Confirm Password</p>
            <Form.Item
              dependencies={['newPassword']}
              hasFeedback
              name="confirmPassword"
              rules={[
                {
                  required: true,
                  message: "Please confirm your new password!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('newPassword') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('The new password that you entered do not match!'));
                  },
                }),
              ]}
            >
              <Input.Password
                size="large"
                placeholder="Confirm Password"
                prefix={<Lock />}
              />
            </Form.Item>
          </div>
          <div className="sm:w-[65%] w-full ">
            <LoadableButton
              type="submit"
              className="w-full text-base font-medium py-2 px-2 rounded-lg text-white bg-primary themeHover"
              lable="Change Password"
              isLoading={isLoading}
              loadingLable="Updating..."
            />
          </div>
        </div>
      </Form>

      <ModalComponent isOpen={isOpen2FAModal} setIsOpen={setIsOpen2FAModal} title='Two Factor Authentication' width={600}>
        <div className='sm:grid grid-cols-12 justify-center items-center '>
          <div className='md:col-span-12 col-span-5 flex flex-col bg-[#FFFFFF] justify-center items-center px-10 py-10 gap-6  w-full'>

            <div className="text-center">
              <p className="text-[#da3a3a] text-sm font-medium auth-com mt-2">
                A verification code has been sent to your email address: {userDetails?.email}
              </p>
              <p className="text-[silver] text-sm font-medium auth-com mt-2  ">
                Please enter the OTP and verify yourself
              </p>
            </div>
            <div className="w-full">
              <Form autoComplete="off" form={formotp} onFinish={handleSubmit2FA}>
                <div className="w-full text-sm py-1">
                  <div className="relative">
                    <Form.Item
                      name="otp"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Input.OTP
                        {...sharedProps}
                        style={{ width: '100%' }}
                      />
                    </Form.Item>
                  </div>
                </div>
                <div className="my-6 flex justify-center">
                  {
                    timer == 0 ? (<button type="button" onClick={open2FAHandle} className="text-sm primary font-bold"><span className="text-black font-normal">Didn't receive it?</span> Resend OTP</button>) : (<p>Resend OTP in {formatTime(timer)}</p>)
                  }
                </div>
                <div className="mt-8">
                  <LoadableButton type='submit' className='bg-primary text-[#FFFFFF] font-semibold text-lg rounded-lg w-full py-2 text' lable='Verify' isLoading={isLoading} loadingLable='Verifying...' />
                </div>
              </Form>
            </div>
          </div>
        </div>
      </ModalComponent>

      <ModalComponent isOpen={isOpenProfileUpdateModal} setIsOpen={setIsOpenProfileUpdateModal} title='Update your profile' width={1200}>
        <Form className="w-full" autoComplete="off" form={updateForm} initialValues={updateInitialValues} onFinish={updateUserProfile}>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            <div className="input-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">First Name</label>
              <Form.Item name="FirstName" rules={[{ required: true, message: "Please enter first name." }]}>
                <Input placeholder="First name" className="mt-1 w-full py-2" />
              </Form.Item>
            </div>
            <div className="input-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Last Name</label>
              <Form.Item name="LastName" rules={[{ required: true, message: "Please enter last name." }]}>
                <Input placeholder="Last name" className="mt-1 w-full py-2" />
              </Form.Item>
            </div>
            <div className="input-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Phone No.</label>
              <Form.Item name="PhoneNo" rules={[{ required: true, message: "Please enter valid phone number." }]}>
                <Input type="number" placeholder="Phone no." className="mt-1 w-full py-2" />
              </Form.Item>
            </div>
            <div className="input-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Date Of Birth</label>
              <Form.Item>
                <DatePicker placeholder="Date of birth" className="mt-1 w-full py-2" defaultValue={updateForm.getFieldValue('DOB') && dayjs(moment(updateForm.getFieldValue('DOB')).format('MM/DD/YYYY'), 'MM/DD/YYYY')} onChange={handleDateChange} format='MM/DD/YYYY' />
              </Form.Item>
            </div>
            <div className="input-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">City</label>
              <Form.Item name="City" >
                <Input placeholder="City" className="mt-1 w-full py-2" />
              </Form.Item>
            </div>
            <div className="input-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Skype</label>
              <Form.Item name="Skype" >
                <Input placeholder="Skype" className="mt-1 w-full py-2" />
              </Form.Item>
            </div>
            <div className="input-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Telegram</label>
              <Form.Item name="Telegram" >
                <Input placeholder="Telegram" className="mt-1 w-full py-2" />
              </Form.Item>
            </div>
            <div className="input-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Facebook</label>
              <Form.Item name="Facebook" >
                <Input placeholder="Facebook" className="mt-1 w-full py-2" />
              </Form.Item>
            </div>
            <div className="input-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">LinkedIn</label>
              <Form.Item name="LinkedIn" >
                <Input placeholder="LinkedIn" className="mt-1 w-full py-2" />
              </Form.Item>
            </div>
            <div className="input-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Experience As IB</label>
              <Form.Item name="ExpAsIb">
                <Input type="number" placeholder="Experience as ib" className="mt-1 w-full py-2" />
              </Form.Item>
            </div>
            <div className="input-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Number Of Clients</label>
              <Form.Item name="NumberofClients">
                <Input type="number" placeholder="Number of clients" className="mt-1 w-full py-2" />
              </Form.Item>
            </div>
            <div className="input-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Working Experience</label>
              <Form.Item name="WorkingExp">
                <Input type="number" placeholder="Working experience" className="mt-1 w-full py-2" />
              </Form.Item>
            </div>
            <div className="input-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Fax</label>
              <Form.Item name="Fax" >
                <Input placeholder="Fax" className="mt-1 w-full py-2" />
              </Form.Item>
            </div>
            <div className="input-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Telephone</label>
              <Form.Item name="Telephone">
                <Input type="number" placeholder="Telephone" className="mt-1 w-full py-2" />
              </Form.Item>
            </div>
            <div className="ant-select-selector-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Country Of Birth</label>
              <Form.Item name="CountryOfBirth">
                <Select showSearch placeholder="Select a country of birth" className="w-full mt-1" filterOption={filterOption} options={countries} />
              </Form.Item>
            </div>
            <div className="ant-select-selector-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Country Of Citizenship</label>
              <Form.Item name="CountryOfCitizenship">
                <Select showSearch placeholder="Select a country of citizenship" className="w-full mt-1" filterOption={filterOption} options={countries} />
              </Form.Item>
            </div>
            <div className="input-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Recovery Contact</label>
              <Form.Item name="RecoveryContact">
                <Input type="number" placeholder="Recovery contact" className="mt-1 w-full py-2" />
              </Form.Item>
            </div>
            <div className="input-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Family Name</label>
              <Form.Item name="FamilyName" >
                <Input placeholder="Family name" className="mt-1 w-full py-2" />
              </Form.Item>
            </div>
            <div>
              <label className="text-base text-[#2F2B3DCC] font-medium">Profile Picture</label>
              <div className="flex w-full items-center justify-between">
                <Form.Item name="ProfileImage">
                  <Upload beforeUpload={() => false} listType="picture-card" className="mt-1" fileList={fileList} onPreview={handlePreview} onChange={handleChange}>{fileList.length >= 1 ? null : UploadButton}</Upload>
                </Form.Item>
                {user?.profileImage &&
                  <div className="ms-4 h-32 w-32 my-auto"><img src={user?.profileImage} alt="preview" className="object-cover w-full h-full" /></div>
                }
              </div>
              <p className="text-sm text-[#2F2B3DCC] font-medium ">max 2mb</p>
              {previewImage && (
                <Image
                  wrapperStyle={{ display: 'none' }}
                  preview={{
                    visible: previewOpen,
                    onVisibleChange: (visible) => setPreviewOpen(visible),
                    afterOpenChange: (visible) => !visible && setPreviewImage(''),
                  }}
                  src={previewImage}
                />
              )}
            </div>
          </div>
          <div className="flex justify-end mt-8">
            <LoadableButton
              className="bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover  duration-500"
              disabled={isLoadingProfileUpdate}
              type="Submit"
              lable="Update"
              isLoading={isLoadingProfileUpdate}
              loadingLable="Updating profile..."
            />
          </div>
        </Form>
      </ModalComponent>
    </div>
  );
}
